import './Contact.css'
import React from "react";
import { Helmet } from 'react-helmet';

const Contact = () => {
    return (
        <div>
            <Helmet>
                <title>New Beginnings Church of The Nazarene | Contact Us</title>
            </Helmet>
            <h1 className="page-header">Contact Us</h1>
            <div>
                <span className='font-weight-bold'>Email</span>
                <span> paulthornhill03@verizon.net</span>
            </div>
            <div>
                <span className='font-weight-bold'>Telephone</span>
                <span> 484-948-9033</span>
            </div>
            <div>
                <span className='font-weight-bold'>Address</span>
                <span> 871 N. Hanover Street, Pottstown, PA 19464</span>
            </div>
        </div>
    );
}

export default Contact;